import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { viVN } from "@mui/x-date-pickers/locales";
import { MdCalendarMonth } from "react-icons/md";
import dayjs from "dayjs";
import "dayjs/locale/vi";
import "./index.css";

const toPickerValue = (value) => {
  if (!value) return null;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed : null;
};

export const DateInput = ({
  id,
  error,
  label,
  value,
  isRequired = false,
  onChange,
  isDisable = false,
}) => {
  const emitChange = (nextValue) => {
    const iso =
      nextValue && nextValue.isValid() ? nextValue.format("YYYY-MM-DD") : "";
    onChange?.({ target: { value: iso } });
  };

  return (
    <div className="wrap-box">
      <div className="wrap">
        <label className="label" htmlFor={id}>
          {label}
        </label>
        <div className={`date-field${isDisable ? " is-disabled" : ""}`}>
          <LocalizationProvider
            dateAdapter={AdapterDayjs}
            adapterLocale="vi"
            localeText={
              viVN.components.MuiLocalizationProvider.defaultProps.localeText
            }
          >
            <DesktopDatePicker
              value={toPickerValue(value)}
              onChange={emitChange}
              format="DD/MM/YYYY"
              disabled={isDisable}
              openTo="year"
              views={["year", "month", "day"]}
              enableAccessibleFieldDOMStructure={false}
              slots={{
                openPickerIcon: MdCalendarMonth,
              }}
              slotProps={{
                textField: {
                  id,
                  required: isRequired,
                },
                openPickerButton: {
                  "aria-label": "Chọn ngày",
                },
                popper: {
                  sx: { zIndex: 2000 },
                },
              }}
              sx={{
                width: "100%",
              }}
            />
          </LocalizationProvider>
        </div>
      </div>
      <span className="error">{error?.message ?? ""}</span>
    </div>
  );
};
